import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "upload",
  "use": "upload-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" fill-rule=\"evenodd\" stroke-linejoin=\"round\" stroke-miterlimit=\"1.414\" id=\"upload\"><path d=\"M3.75,20.319L20.25,20.319L20.25,17.639L23,17.639L23,20.319C23,21.796 21.768,23 20.25,23L3.75,23C2.232,23 1,21.796 1,20.319L1,17.639L3.75,17.639L3.75,20.319ZM10.625,6.131L10.625,18.979L13.375,18.979L13.375,6.131L17.903,10.544L19.847,8.649L12,1L4.153,8.649L6.097,10.544L10.625,6.131Z\" fill=\"currentColor\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol